module.exports = __webpack_public_path__ + "static/media/rvt.ec8518d0.png";